//imports
import {
    NOTES_DELETE_REQUEST,
    NOTES_DELETE_RESULT,
    NOTES_DELETE_OPEN_MODAL,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    note: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case NOTES_DELETE_REQUEST:
            return { ...state, loading: true }

        case NOTES_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case NOTES_DELETE_OPEN_MODAL:
            return { ...state, openModal: true, note: action.payload }

        case CLEAR_REDUX:
            return ["", "NOTES_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};